import { SelectWithSearch, VerifyComponent } from "components";
import React, { useEffect, useState } from "react";
import { FormGroup, Row, Textarea } from "styles/forms/main";
import { getAllSuppliers } from "../api";
import { useSelector } from "react-redux";
import { getUserRoles } from "modules/auth/slice";

const SupplierVerify = ({ truckData, isQARole, handleObjections }) => {
    const [allSuppliers, setAllSuppliers] = useState(null);
    const [objection, setObjections] = useState({});
    const getCurrentUserRole = useSelector(getUserRoles()).filter((role) => role === "reviewer");

    const openObjectionhandler = (fieldName) => {
        setObjections({
            ...objection,
            [fieldName]: {
                haveobjection: true,
                verified: false,
            },
        });
    };
    const handleVerify = (fieldName, item, section, category) => {
        setObjections({
            ...objection,
            [fieldName]: {
                verified: true,
                haveobjection: false,
            },
        });
        handleObjections(null, item, section, category, true);
    };
    const handleGetSuppliers = async () => {
        const data = await getAllSuppliers();
        setAllSuppliers(data);
    };
    useEffect(() => {
        handleGetSuppliers();
    }, []);
    return (
        <>
            <FormGroup>
                <Row>
                    <SelectWithSearch
                        label="Supplier"
                        isEditable={false}
                        disable={false}
                        options={allSuppliers}
                        value={truckData?.supplierName}
                    />
                    {getCurrentUserRole[0] === "reviewer" && isQARole && (
                        <VerifyComponent
                            objectionHandler={() => openObjectionhandler("supplier")}
                            handleVerify={() =>
                                handleVerify(
                                    "supplier",
                                    "Supplier",
                                    "Supplier Info - Truck",
                                    "truck_profile"
                                )
                            }
                            verifed={
                                objection?.supplier?.verified
                                    ? objection?.supplier?.verified
                                    : false
                            }
                            objection={
                                objection?.supplier?.haveobjection
                                    ? objection?.supplier?.haveobjection
                                    : false
                            }
                        />
                    )}
                </Row>
                {objection?.supplier?.haveobjection && (
                    <Textarea
                        autoFocus
                        required
                        onBlur={(e) => {
                            handleObjections(
                                e,
                                "Supplier",
                                "Supplier Info - Truck",
                                "truck_profile",
                                false
                            );
                        }}
                    />
                )}
            </FormGroup>
        </>
    );
};

export default SupplierVerify;
